export const PINNED_COLUMN_CLASSES = {
	left: 'sticky left-0 bg-container-bg group-hover:bg-button-disabled z-10',
	right: 'sticky right-0 bg-container-bg group-hover:bg-button-disabled z-10',
} as const;

/**
 * Scrim cast over the scrolling content next to a pinned column, so the frozen
 * column reads as sitting above the rest of the row. Translucent, so the row's
 * own hover background still shows through.
 */
export const PINNED_COLUMN_STUCK_CLASSES = {
	left: "before:content-[''] before:pointer-events-none before:absolute before:top-0 before:left-full before:h-full before:w-4 before:bg-gradient-to-r before:from-main-bg/40 before:to-transparent",
	right:
		"before:content-[''] before:pointer-events-none before:absolute before:top-0 before:right-full before:h-full before:w-4 before:bg-gradient-to-l before:from-main-bg/40 before:to-transparent",
} as const;

export const TABLE_DEFAULT_EMPTY_MESSAGE = 'No data found';
